import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { LicenseTransferMemberRequest } from '../../models/ss-api/requests/license.transfer.member.request';
import { Router } from '@angular/router';

export interface IKeyTransferDialogModel {
    CDKey: string;
}

@Component({
    selector: 'key-transfer-dialog',
    styleUrls: ['./key.transfer.dialog.css'],
    templateUrl: './key.transfer.dialog.html'
})
export class KeyTransferDialog extends DialogComponent<IKeyTransferDialogModel, boolean> implements IKeyTransferDialogModel {
    IsBusy: boolean = false;
    CDKey: string;
    NewMemberID: string;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    async confirm() {

        this.IsBusy = true;

        if (this.NewMemberID == undefined || this.NewMemberID == '') {
            await this.sweetAlertService.swal(
                {
                    title: 'Error',
                    text: 'No New Member ID was provided!',
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    allowOutsideClick: false,
                })
                .then(response => {
                    this.IsBusy = false;
                    return;
                }, dismiss => {
                    this.IsBusy = false;
                    return;
                });
            return;
        }

        let request = new LicenseTransferMemberRequest;
        request.LicenseKey = this.CDKey;
        request.MemberID = this.NewMemberID;

        await this.sweetAlertService.swal(
            {
                title: 'Transfer Key?',
                text: 'Are you sure you want to transfer this License Key?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                preConfirm: () => {
                    return this.api.LicenseTransferMember(request).toPromise();
                }
            })
            .then(response => {
                this.result = true;
                this.close();
                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'License Key Transfered',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        this.IsBusy = false;
                        this.close();
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });




    }

    confirmBK() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }

}
